import { Component, OnInit, Output, EventEmitter, HostBinding } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SelectItem } from '../../../lib/common';
import { ROUND_ANTICLOCK_ANIMATION } from '../shared/animations/round-anticlock.animation';
import { ON_OFF_ANIMATION } from '../shared/animations/on-off.animation';
import { FLY_IN_OUT_ANIMATION } from '../shared/animations/fly-in-out.animation';
import { SLIDE_IN } from '../shared/animations/slide-in.animation';
import { CommonFilterService } from 'src/app/shared/services/common-filter/common-filter.service';

@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss'],
  animations: [
    FLY_IN_OUT_ANIMATION 
  ]
})
export class FiltersComponent implements OnInit {
  //@HostBinding('@roundAntiClockTrigger') roundAntiClockTrigger = 'in';
  @HostBinding('@flyInOutTrigger') flyInOutTrigger = 'in';
  rsltType: string = "filters";

  title: string = "Filters";
  staticScreen = true;
  @Output() childTitleEvent = new EventEmitter();

  myFilterName = 'null';
  basicFilterRefresh = false;
  constructor(private router: Router, private routeAct: ActivatedRoute, private commonFilterService: CommonFilterService) {
    this.routeAct.params.subscribe((params: Params) => this.myFilterName = params['filter-name']);
    this.commonFilterService.componentFilterMethodSavedCalled$.subscribe(res => {
      this.basicFilterRefresh = true;
    });
  }

  disableClose = true;
  ngOnInit() {
    this.parentEvent();
    setTimeout(() => { this.disableClose = false; }, 1200);
  }

  close() {
    if (this.basicFilterRefresh == true) {
      this.commonFilterService.basicFilterRefresh(2);//For refreshing main screen after modify filters closed
    }
    //this.commonFilterService.basicCRRefresh();//NOT NEEDED AS Refresh already is taking care
    this.router.navigate([{ outlets: { filterPopup: null, configPopup: null } }]);
  }

  parentEvent() {
    this.childTitleEvent.emit({ title: this.title, staticScreen: this.staticScreen });
  }

  tabs: SelectItem[] = [
    { id: 1, name: 'By Results Parameters' },
    { id: 2, name: 'Add Extra Parameters' },
  ];

  onSelectTab(event) {
    //console.log(event);
  }
}
